import { z } from "zod";
import { BladeCommonSchema } from "../common";
import { LinkItemSchema } from "../../fragments/LinkItem";
import { RichTextSchema } from "../../fragments/RichText";
export const RsoModalSchema = BladeCommonSchema.extend({
    rsoModalTitle: z.string().optional(),
    description: z.string().optional(),
    signupPrompt: z.string(),
    signupLink: LinkItemSchema,
    loginPrompt: z.string(),
    loginLink: LinkItemSchema,
    subtext: RichTextSchema.optional(),
    productAttribution: z.string().optional(),
});
const RiotBarBladeTypeValues = ["riotbar"];
export const RiotBarBladeTypesSchema = z.enum(RiotBarBladeTypeValues);
export const RiotBarBladeTypes = RiotBarBladeTypesSchema.enum;
export const RiotBarBladeSchema = BladeCommonSchema.extend({
    productId: z.string(),
    locale: z.string(),
    environment: z.string(),
    rsoModal: RsoModalSchema.optional(),
});
export const RiotBarBladesContractSchema = RiotBarBladeSchema.extend({
    type: RiotBarBladeTypesSchema,
});
export const RiotBarContractSchema = RiotBarBladesContractSchema.extend({
    type: z.literal(RiotBarBladeTypes.riotbar),
});
//# sourceMappingURL=index.js.map